<template>
<div v-if="contractInfo" class="tab-wrapper">
  <h3 class="mb16">{{contractInfo.projectName}}<span class="dot">.</span>{{contractInfo.stockNumber}}</h3>
  <div class="content">
    <div class="item pt16 pb16">
      <h4 class="mb8">签约信息</h4>
      <Row>
        <Col span="8">合同编号：<span class="info">{{contractInfo.contractCode}}</span></Col>
        <Col span="8">合同状态：<span class="info">{{contractInfo.contractStateName}}</span></Col>
        <Col span="8">租约类型：<span class="info">{{contractInfo.rentTypeName}}</span></Col>
        <Col span="8">签约类型：<span class="info">{{contractInfo.contractTypeName}}</span></Col>
        <Col span="8">签约日期：<span class="info">{{contractInfo.conSignDate}}</span></Col>
        <Col span="8">起租日期：<span class="info">{{contractInfo.conStartDate}}</span></Col>
        <Col span="8">到期日期：<span class="info">{{contractInfo.conEndDate}}</span></Col>
        <Col span="8">签约租期时长：<span class="info">{{contractInfo.conRentDuration}}</span></Col>
        <Col span="8">付款方式：<span class="info">{{contractInfo.conCycleCodeName}}</span></Col>
        <Col span="8">签约ZO：<span class="info">{{contractInfo.handleZo}}</span></Col>
        <Col span="8">合同备案号：<span class="info">{{contractInfo.caseNum}}</span></Col>
        <Col span="8">前合同号：<span class="info">{{contractInfo.preContractCode}}</span></Col>
      </Row>
    </div>
  </div>

  <div class="content" v-if="contractInfo.channelType">
    <div class="item pt16 pb16">
      <h4 class="mb8">客户来源信息</h4>
      <Row>
        <Col span="6">客户来源渠道：<span class="info">{{contractInfo.channelTypeName}}</span></Col>
        <template v-if="contractInfo.haveChannelInfo">
          <Col span="4">姓名：<span class="info">{{contractInfo.channelUserName}}</span></Col>
          <Col span="4">工号：<span class="info">{{contractInfo.channelUserCode}}</span></Col>
          <Col span="4">手机号：<span class="info">{{contractInfo.channelUserPhone}}</span></Col>
          <Col span="4">业绩：<span class="info">{{contractInfo.zoAchievements}}</span></Col>
        </template>
      </Row>
      <Row v-if="contractInfo.haveChannelInfo">
        <Col span="6">组织机构：<span class="info">{{contractInfo.channelGroupName}}</span></Col>
        <Col span="4">主管姓名：<span class="info">{{contractInfo.channelLeaderName}}</span></Col>
        <Col span="4">主管系统号：<span class="info">{{contractInfo.channelLeaderCode}}</span></Col>
        <Col span="4">总监姓名：<span class="info">{{contractInfo.channelLeaderSuperiorName}}</span></Col>
        <Col span="4">总监系统号：<span class="info">{{contractInfo.channelLeaderSuperiorCode}}</span></Col>
      </Row>
    </div>
  </div>

  <div class="item pt16 pb16">
    <h4 class="mb8">价格明细</h4>
    <table-list :showPage ="false" :columns="columns" :data="contractInfo.contractPriceDetailVoList" :loading="loading"></table-list>
  </div>
  <div class="item pt16 pb16">
    <h4 class="mb8">审核信息</h4>
    <div class="table-wrap">
      <table class="ivu-table" cellspacing="0" cellpadding="0" border="0" >
        <thead>
          <tr>
            <th>审核操作</th>
            <th>审核人</th>
            <th>审核时间</th>
            <th>审核备注</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="ivu-table-column-center">{{contractInfo.auditStateName || '-'}}</td>
            <td class="ivu-table-column-center">{{contractInfo.conAuditer || '-'}}</td>
            <td class="ivu-table-column-center">{{contractInfo.contractAuditDate || '-'}}</td>
            <td class="ivu-table-column-center">{{contractInfo.noRenewalReason || '-'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

</template>

<script type="text/ecmascript-6">
import defaultImg from '@/assets/filedefault.jpg'
 import TableList from "components/TableList/index";
export default {
  props:{
    contractInfo:{
      type:Object,
      default:null
    }
  },
  components:{
    TableList
  },
 data () {
  return {
    loading:false,
    columns:[
    {
      title: "费用项",
      key: "feeName",
      align: "center"

    },
    {
      title: "标准金额",
      key: "standardMoney",
      align: "center"
    },
    {
      title: "实际金额",
      key: "realMoney",
      align: "center"
    },
    {
      title: "优惠金额",
      key: "discountMoney",
      align: "center"
    },
    {
      title: "涨幅/优惠/活动等",
      key: "activityName",
      align: "center",
      render: (h,params) => {
        return h('div',params.row.activityName || '-')
      }
    }
    ],
   priceList:[]
 };
 },
 methods:{

 }
}
</script>
<style scoped>

.ivu-row, p {
  line-height: 3;
}
.info {
  padding-left: 8px;
  font-weight: 600;
}
.table-wrap {
  position: relative;
  border: 1px solid #dddee1;
    border-bottom: 0;
    border-right: 0;
}
table {
  width: 100%;
}
th,td {
  text-align: center;
}
.dot {
  vertical-align: text-bottom;
  padding: 0 4px;
}
</style>

